/** Print + QR helpers shared by all printable documents. */
import { useEffect, useState } from "react";
import QRCode from "qrcode";

/** Prints the passed element via CSS `.am-print-target` isolation. */
export function printElement(el) {
  if (!el) return;
  document.querySelectorAll(".am-print-target").forEach((n) => n.classList.remove("am-print-target"));
  el.classList.add("am-print-target");
  const cleanup = () => {
    el.classList.remove("am-print-target");
    window.removeEventListener("afterprint", cleanup);
  };
  window.addEventListener("afterprint", cleanup);
  window.print();
}

/** 58mm thermal-roll print — injects a temporary @page override, fully offline. */
export function printThermal(el) {
  if (!el) return;
  const style = document.createElement("style");
  style.textContent = `@page { size: 58mm auto; margin: 0; }
@media print {
  .am-print-target { width: 58mm !important; max-width: 58mm !important; border-radius: 0 !important; box-shadow: none !important; padding: 2mm !important; font-size: 10px !important; }
  .am-print-target img[alt="Gate Pass QR"] { width: 40mm !important; height: 40mm !important; }
  .am-print-target img[alt="Animal"] { display: none !important; }
}`;
  document.head.appendChild(style);
  const cleanup = () => { style.remove(); window.removeEventListener("afterprint", cleanup); };
  window.addEventListener("afterprint", cleanup);
  printElement(el);
}

export function useQrDataUrl(payload, size = 512) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!payload) { setUrl(""); return; }
    QRCode.toDataURL(payload, { width: size, margin: 1, errorCorrectionLevel: "M" })
      .then(setUrl)
      .catch((err) => { console.warn("QR generation failed", err); setUrl(""); });
  }, [payload, size]);
  return url;
}
